export default __webpack_public_path__ + "static/media/bonusMoneyLambda.28ab483b.png";